import { logoSvg } from 'assets/images';
import { errorMessage } from 'constants/CommonConstants';
import { formRequiredRules } from 'helper';
import { RENT_OR_OWN } from 'pages/leadGen/LeadGenConstant';
import React, { useImperativeHandle } from 'react';
import { useFormContext } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import { StepperFromProps } from 'sharedComponents/dynamicStepperForm/dynamicStepperFormInterface';
import { CommonInput } from 'sharedComponents/inputGroup';
import { InputRadio } from 'sharedComponents/inputGroup/InputRadio';

import Email from '../icons/envelope.svg';
import LocationPin from '../icons/locationpin.svg';

const Step7: React.ForwardRefRenderFunction<unknown, StepperFromProps> = ({ onBack }, ref) => {
  const { t } = useTranslation();
  const { control, trigger, getValues } = useFormContext();

  const getFormValues = (name: string) => {
    return getValues(name);
  };

  const backStep = () => {
    onBack?.();
  };

  useImperativeHandle(ref, () => ({
    backStep,
  }));

  return (
    <>
      <div className='csc-screens__form-col shadow'>
        <div className='logo'>
          <img src={logoSvg} alt='Dabadu' className='img-fluid' />
        </div>
        <div className='csc-screens__form-col__top'>
          <div className='csc-screens__user-info'>
            <div className='csc-screens__user-info__name'>{`${getFormValues('first')} ${getFormValues('last')}`}</div>
            <ul className='csc-screens__user-info__list list-unstyled mb-0'>
              <li>
                <span className='csc-screens__user-info__list__icon'>
                  <img src={Email} alt='Envelope' />
                </span>
                {getFormValues('emailAddress')}
              </li>
              <li>
                <span className='csc-screens__user-info__list__icon'>
                  <img src={LocationPin} alt='Location' />
                </span>
                {getFormValues('address')?.label}
              </li>
            </ul>
          </div>
        </div>
        <div className='csc-screens__form-col__middle'>
          <h5 className='csc-screens__form-col__middle__title'>{t('stepperForm.employmentInformation')}</h5>

          <div className='csc-screens__field-wrapper'>
            <div className='form-group'>
              <CommonInput
                name='grossMonth'
                control={control}
                label={t('stepperForm.grossMonthIncome')}
                rules={formRequiredRules(errorMessage(t).grossMonthRequired)}
                triggerValidationForField={trigger}
              />
            </div>
            <div className='form-group'>
              <CommonInput
                name='timeAtJobYear'
                control={control}
                type='number'
                label={t('stepperForm.timeAtJobYear')}
                rules={formRequiredRules(errorMessage(t).timeAtJobRequired)}
                triggerValidationForField={trigger}
              />
            </div>
            <div className='form-group'>
              <CommonInput
                name='timeAtJobMonth'
                control={control}
                type='number'
                label={t('stepperForm.timeAtJobMonth')}
                rules={formRequiredRules(errorMessage(t).timeAtJobRequired)}
                triggerValidationForField={trigger}
              />
            </div>
            <div className='form-group'>
              <CommonInput
                name='currentEmployerName'
                control={control}
                label={t('stepperForm.nameOfEmployer')}
                rules={formRequiredRules(errorMessage(t).employerNameRequired)}
                triggerValidationForField={trigger}
              />
            </div>
            <div className='form-group'>
              <CommonInput
                name='jobTitle'
                control={control}
                label={t('stepperForm.jobTitle')}
                rules={formRequiredRules(errorMessage(t).jobTitleRequired)}
                triggerValidationForField={trigger}
              />
            </div>

            <div className='form-group'>
              <p className='lead'>{t('stepperForm.residenceInformation')}</p>
              <InputRadio
                name={'rentOrOwn'}
                control={control}
                label={t('stepperForm.doYouRentOrOwn')}
                rules={formRequiredRules(errorMessage(t).residentInformationRequired)}
                options={RENT_OR_OWN(t)}
                triggerValidationForField={trigger}
              />
            </div>
            <div className='form-group'>
              <CommonInput
                name='monthlyHousePayment'
                control={control}
                label={t('stepperForm.monthlyRentMortgagePayment')}
                rules={formRequiredRules(errorMessage(t).paymentRequired)}
                triggerValidationForField={trigger}
              />
            </div>
            <div className='form-group'>
              <CommonInput
                name='recidenceYear'
                type='number'
                control={control}
                label={t('stepperForm.timeAtResidenceYear')}
                rules={formRequiredRules(errorMessage(t).recidenceRequired)}
                triggerValidationForField={trigger}
              />
            </div>

            <div className='form-group'>
              <CommonInput
                name='recidenceMonth'
                type='number'
                control={control}
                label={t('stepperForm.timeAtResidenceMonth')}
                rules={formRequiredRules(errorMessage(t).recidenceRequired)}
                triggerValidationForField={trigger}
              />
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

const StepperForm7 = React.forwardRef(Step7);

export default StepperForm7;
